export default "__VITE_ASSET__rVgYgk8U__"